export default __webpack_public_path__ + "static/media/pantry2-after2-480w.540c0161.avif";